import {BlinkGlobal} from "../../../blinkpay/UtilsLib";
import type {StoreId} from "../../../stem-core/state/State";

export function filterStoreByMerchantAndLooseIdArray<T extends { merchantId?: StoreId }>(
    unfilteredObjects: T[],
    looseIdArray: StoreId[],
    looseIdMatches: (obj: T, idOrName: StoreId) => boolean
): T[] {
    const merchantId = BlinkGlobal.iFrameMerchantService?.merchantId;
    if (merchantId) {
        unfilteredObjects = unfilteredObjects.filter(obj => obj.merchantId === merchantId);
    }
    if (looseIdArray) {
        unfilteredObjects = looseIdArray.map(id => unfilteredObjects.find(obj => looseIdMatches(obj, id)))
            .filter(Boolean) as T[];
    }
    return unfilteredObjects;
}
